





import { defineComponent } from '@vue/composition-api';

import PanelWithSpeakerEditor from '@/components/Speaker/PanelWithSpeakerEditor.vue';

const Edit = defineComponent({
  components: {
    PanelWithSpeakerEditor,
  },
  // setup() {},
});

export default Edit;
